import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useAuthUser } from "react-auth-kit";
import { axios } from "../lib/request";

export const fetchUser = async (game_id, customHeaders) => {
  let user = {}
  const url = process.env.REACT_APP_API_WHOAMI_URL;
  const params = game_id === "new" ? {} : { game_id };
  // customHeaders is used to override request token when fetching user data
  const response = await axios.get(url, { params, ...(customHeaders ? { customHeaders } : {}) });
  const { data } = response || {}
  user = data
  return user;
};

export const useUserDataQuery = (game_id) => {
  const auth = useAuthUser()();
  const userKey = auth?.user_id || "anonymous";

  // Keep user data in cache indefinitely as long as the user is logged in
  return useQuery(["whoami", userKey, game_id], () => fetchUser(game_id), {
    suspense: true,
    keepPreviousData: true,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
};

export const useUserQuery = () => {
  const { game_id } = useParams();
  const { data } = useUserDataQuery(game_id);

  return data;
};



export const useUserByGameIdQuery = (game_id) => {
  const { data } = useUserDataQuery(game_id);

  return data || {};
};